export const ID_WIDTH = 50;
export const ACTIONS_WIDTH = 100;
export const PRICE_WIDTH = 100;
export const NAME_MIN_WIDTH = 150;
export const ACTIVE_WIDTH = 75;
export const ALCOHOL_TYPE_WIDTH = 150;
export const TYPE_WIDTH = 100;
export const BEER_TYPE_WIDTH = 150;
export const PRICE_TIER_WIDTH = 120;
export const DEFAULT_WIDTH = 180;
export const DISPLAY_ORDER_WIDTH = 180;
